module.exports = __webpack_public_path__ + "media/images/download-3bab9c6223e5dcffed9a67479745948b.svg";